import { render, staticRenderFns } from "./FakeSiteNavigation.vue?vue&type=template&id=5f4d14cd&"
import script from "./FakeSiteNavigation.vue?vue&type=script&lang=js&"
export * from "./FakeSiteNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports